import React, {useEffect} from 'react';
import styled, {keyframes} from "styled-components";
import {handleLockBrowserScroll} from "../helpers/helpers";

const BrandBulletLoading = ({show}) => {

    useEffect(() => {
        const root = document.getElementsByTagName('html')[0];

        if (show) {
            handleLockBrowserScroll(true);
        } else {
            handleLockBrowserScroll(false);
        }
    }, [show]);

    return (
        <Container className={'bullet-loading ' + (show ? 'show-bullet-loading' : '')}>
            <Loading className="bullet-loading-box">
                <div className="brand-logo">
                    <img src="/_img/2nabsh.svg" alt="2nabsh logo"/>
                </div>
                <div className="loader-bullets">
                    <i className="loader-bullet loader-bullet-1"/>
                    <i className="loader-bullet loader-bullet-2"/>
                    <i className="loader-bullet loader-bullet-3"/>
                    <i className="loader-bullet loader-bullet-4"/>
                </div>
            </Loading>
        </Container>
    );
};

export default React.memo(BrandBulletLoading);

// styles
const Container = styled.div`
    display: none;
    position: fixed;
    height: 100%;
    width: 100%;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    margin: auto;
    background: rgba(256, 256, 265, 1);
    z-index: 5060;
    
    &.show-bullet-loading {
        display: block;
    }
`;

const loading_dots_fadein = keyframes`
    to {
        opacity: 1
    }
`;

const loading_dots_first_dot = keyframes`
    to {
        -webkit-transform: translateX(14px);
        transform: translateX(14px);
        opacity: 1
    }
`;


const loading_dots_middle_dots = keyframes`
    to {
        -webkit-transform: translateX(14px);
        transform: translateX(14px)
    }
`;

const loading_dots_last_dot = keyframes`
    to {
        -webkit-transform: translateX(28px);
        transform: translateX(28px);
        opacity: 0
    }
`;

const Loading = styled.div`
    position: fixed;
    top: 50%;
    right: 50%;
    transform: translate(50%, -50%);
    text-align: center;
    overflow: hidden !important;
    line-height: 22px;

    .brand-logo {
        position: relative;
        height: 56px;
        display: flex;
        align-items: center;
        margin: 0 auto 32px;
    
        @media (max-width: ${props => props.theme.screenSmMax}) {
            height: 40px;
        }
    
        img {
            width: 100%;
            height: 100%;
            background-color: transparent;
        }
    }

    .loader-bullets {
        margin: auto auto auto -21px;
        opacity: 0;
        filter: alpha(opacity=0);
        -webkit-animation: ${loading_dots_fadein} .5s linear forwards;
        animation: ${loading_dots_fadein} .5s linear forwards;
        direction: ltr;
    
        .loader-bullet {
            border-radius: 100%;
            overflow: hidden;
            background-color: ${props => props.theme.secondary};
            width: 7px;
            height: 7px;
            display: inline-block;
            vertical-align: middle;
            margin: 0 4px;
            -webkit-animation: ${loading_dots_middle_dots} .5s ease-in-out infinite;
            animation: ${loading_dots_middle_dots} .5s ease-in-out infinite;
        
            &:first-child {
                -webkit-animation: ${loading_dots_first_dot} .5s ease-in-out infinite;
                animation: ${loading_dots_first_dot} .5s ease-in-out infinite;
                opacity: 0;
                -webkit-transform: translate(-14px);
                transform: translate(-14px);
            }

            &:last-child {
                -webkit-animation: ${loading_dots_last_dot} .5s ease-in-out infinite;
                animation: ${loading_dots_last_dot} .5s ease-in-out infinite;
            }
        }
    }
`;